import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useCustomerAction, useEllipsis, useGradient } from "@/hooks";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { InteractionEnum } from "@/types";
import { ExpandableTextEllipsisBtn } from "./ExpandableTextEllipsisBtn";
import { AnimatedChevronIcon } from "./AnimatedChevronIcon";
import { useThrottledWidthObserver } from "@/hooks/useThrottledWidthObserver";
import { formatTextWithHtml } from "@/utils";
export const ExpandableText = ({ text, nbLines, testId, withGradient, }) => {
    const [isExpanded, setIsExpanded] = useState(Boolean(false));
    const { ref: ellipsisRef, ellipsisStyle, hasButton: hasEllipsisButton, } = useEllipsis(nbLines);
    const { ref: gradientRef, hasButton: hasGradiantButton, gradientStyle, } = useGradient(nbLines);
    const ref = withGradient ? gradientRef : ellipsisRef;
    const collapseStyle = withGradient && hasGradiantButton ? gradientStyle : ellipsisStyle;
    const { t } = useI18n();
    const buttonLabel = isExpanded ? t("cta.see_less") : t("cta.see_more");
    const LINE_HEIGHT = 24;
    const collapsedHeight = LINE_HEIGHT * nbLines;
    const [contentHeight, setContentHeight] = useState(collapsedHeight);
    const { customerActionLeadInteraction } = useCustomerAction();
    const trackCustomerActionSectionReadMore = (title) => {
        customerActionLeadInteraction(InteractionEnum.OPEN_MORE, title);
    };
    useEffect(() => {
        var _a;
        if (isExpanded) {
            setContentHeight((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.scrollHeight);
        }
        else {
            setContentHeight(collapsedHeight);
        }
    }, [isExpanded, ref, withGradient, contentHeight, collapsedHeight]);
    useThrottledWidthObserver(ref, () => {
        if (!isExpanded)
            setContentHeight(collapsedHeight);
    });
    const onPress = () => {
        if (!isExpanded && hasGradiantButton) {
            trackCustomerActionSectionReadMore(t("description.modal.title"));
        }
        setIsExpanded(!isExpanded);
        if (isExpanded) {
            ref.current.scrollIntoView({ behavior: "instant" });
            window.scrollBy(0, -200);
        }
    };
    const renderAnimatedChevronIcon = (isExpanded) => (_jsx(AnimatedChevronIcon, { isExpanded: isExpanded }));
    const displayTextButton = (hasEllipsisButton && !withGradient) || (hasGradiantButton && withGradient);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { ref: ref, unsafe_style: isExpanded ? null : collapseStyle, dangerouslySetInnerHTML: { __html: formatTextWithHtml(text) }, transitionDuration: "unsafe_component.accordion.motionDuration", transitionTimingFunction: "unsafe_component.accordion.motionEasing", maxHeight: contentHeight, whiteSpace: "pre-line", width: "100%", testId: testId, unsafe_className: "DescriptionTexts", overflow: "hidden" }), displayTextButton && (_jsx(ExpandableTextEllipsisBtn, { testId: testId, onPress: onPress, buttonLabel: buttonLabel, icon: () => renderAnimatedChevronIcon(isExpanded), isGradientVersion: withGradient }))] }));
};
